export default function checkIfCanUpdateSuggestionRoutes({ next, store }) {
  let scopes = store.getters.userScopes;
  return scopes.includes('suggestions_update') ? next() : next({ name: 'dashboard' });
}
